import AboutUs from "./AboutUs";
import PanerFarm from "./BoxPanerFarm";
import CarbonCertificate from "./CarbonCertificate";
import CarbonFootprint from "./CarbonFootprint";
import ChooseUs from "./ChooseUs";
import Deforestation from "./Deforestation";
import Ecosystem from "./Ecosystem";
import HowWeWork from "./HowWeWork";
import OurImpact from "./OurImpact";
import Planet from "./Planet";
import Regenerative from "./Regenerative";
import Foodter from "./foodter";
import { Wapper, GetStarted } from "./style";

const Body = () => {
  return (
    <Wapper>
      <GetStarted>
        <button>GET STARTED</button>
      </GetStarted>
      <AboutUs />
      <Deforestation/>
      <Planet />
      <CarbonFootprint />
      <CarbonCertificate />
      <HowWeWork/>
      <PanerFarm />
      <OurImpact />
      <ChooseUs/>
      <Regenerative/>
      <Ecosystem/>
      <Foodter/>
    </Wapper>
  );
};
export default Body;
